import { render, staticRenderFns } from "./DialogTicket.vue?vue&type=template&id=1e37408a"
import script from "./DialogTicket.vue?vue&type=script&lang=js"
export * from "./DialogTicket.vue?vue&type=script&lang=js"
import style0 from "./DialogTicket.vue?vue&type=style&index=0&id=1e37408a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports